if (!customElements.get('crosssell-block')) {
  customElements.define(
    'crosssell-block',
    class CrosssellBlock extends HTMLElement {
      connectedCallback() {
        this.swiperEl = this.querySelector('.tp-crosssell-block__swiper');
        if (this.swiperEl && window.Swiper) {
          this.swiper = new Swiper(this.swiperEl, {
            slidesPerView: 2.2,
            spaceBetween: 12,
            freeMode: true,
            watchOverflow: true,
            breakpoints: {
              480: { slidesPerView: 2.5 },
              749: { slidesPerView: 3.2 },
            },
          });
        }

        this.addEventListener('click', this.onClick.bind(this));
      }

      disconnectedCallback() {
        if (this.swiper) this.swiper.destroy(true, false);
      }

      onClick(event) {
        const button = event.target.closest('.tp-crosssell-block__product-card-button');
        if (!button || button.disabled) return;

        event.preventDefault();
        this.addToCart(button);
      }

      addToCart(button) {
        const variantId = button.dataset.variantId;
        if (!variantId) return;

        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        button.disabled = true;
        button.classList.add('loading');

        const config = fetchConfig('javascript');
        config.body = JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: cart ? cart.getSectionsToRender().map((section) => section.id) : [],
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'crosssell-block',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'crosssell-block', productVariantId: variantId });
            if (cart) {
              if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
              cart.renderContents ? cart.renderContents(response) : cart.open && cart.open();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            button.disabled = false;
            button.classList.remove('loading');
          });
      }
    }
  );
}
